import { render, staticRenderFns } from "./ListFaturaPage.vue?vue&type=template&id=522c928a"
import script from "./ListFaturaPage.vue?vue&type=script&lang=js"
export * from "./ListFaturaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports